module.exports = __webpack_public_path__ + "img/personal1.0ca1af52.png";